import { Injectable } from '@angular/core';
import { AmplitudeService } from './amplitude.service';

@Injectable()
export class AnalyticsService {
  constructor(private readonly amplitudeService: AmplitudeService) {}

  public trackEvent(eventName: string, payload: { [key: string]: string }) {
    void this.amplitudeService.logAmplitudeEvent(eventName, payload);
  }
}
